module.exports = {
	"id": "SO",
	"name": "Somalia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.001197,
			"9": 0.031122,
			"10": 0.002394,
			"11": 0.009576,
			"12": 0.003591,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.003591,
			"17": null,
			"18": null,
			"19": 0.001197,
			"20": 0.016758,
			"21": 0.043092,
			"22": 0.001197,
			"23": 0.031122,
			"24": 0.005985,
			"25": 0.005985,
			"26": 0.02394,
			"27": null,
			"28": 0.003591,
			"29": 0.007182,
			"30": 0.007182,
			"31": 0.079002,
			"32": 0.004788,
			"33": 0.262143,
			"34": 0.005985,
			"35": 0.004788,
			"36": 0.004788,
			"37": 0.004788,
			"38": 0.004788,
			"39": 0.016758,
			"40": 0.009576,
			"41": 0.008379,
			"42": 0.013167,
			"43": 1.497447,
			"44": 0.01197,
			"45": 0.015561,
			"46": 0.010773,
			"47": 0.021546,
			"48": 0.009576,
			"49": 0.146034,
			"50": 0.037107,
			"51": 0.229824,
			"52": 0.102942,
			"53": 4.074588,
			"54": 1.230516,
			"55": 0.050274,
			"56": 0.014364,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.050274,
			"4": 0.004788,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.001197,
			"11": 0.007182,
			"12": 0.002394,
			"13": 0.002394,
			"14": null,
			"15": 0.003591,
			"16": 0.001197,
			"17": 0.001197,
			"18": null,
			"19": 0.005985,
			"20": 0.005985,
			"21": 0.005985,
			"22": 0.003591,
			"23": 0.010773,
			"24": 0.005985,
			"25": 0.002394,
			"26": 0.001197,
			"27": null,
			"28": 0.001197,
			"29": 0.014364,
			"30": 0.009576,
			"31": 0.007182,
			"32": 0.001197,
			"33": 0.007182,
			"34": 0.004788,
			"35": 0.010773,
			"36": 0.015561,
			"37": 0.021546,
			"38": 0.017955,
			"39": 0.007182,
			"40": 0.005985,
			"41": 0.009576,
			"42": 0.019152,
			"43": 0.093366,
			"44": 0.049077,
			"45": 0.027531,
			"46": 0.026334,
			"47": 0.220248,
			"48": 0.149625,
			"49": 0.831915,
			"50": 0.132867,
			"51": 0.002394,
			"52": null,
			"3.5": null,
			"3.6": 0.004788
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.001197,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005985,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.002394,
			"34": null,
			"35": 0.002394,
			"36": 0.007182,
			"37": 0.033516,
			"38": 0.021546,
			"39": 0.007182,
			"40": 0.241794,
			"41": 0.019152,
			"42": 0.003591,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.002394,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.001197
		},
		"safari": {
			"0": null,
			"4": 0.004788,
			"5": 0.001197,
			"6": null,
			"7": 0.003591,
			"8": 0.008379,
			"9": 0.007182,
			"10": 0.050274,
			"3.1": null,
			"3.2": null,
			"5.1": 0.005985,
			"6.1": 0.004788,
			"7.1": null,
			"9.1": 0.073017
		},
		"ios_saf": {
			"8": 0,
			"10": 0.631858963364,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0170278679226,
			"8.1-8.4": 0.0314582644671,
			"9.0-9.2": 0.0150076124063,
			"9.3": 0.22896229184
		},
		"android": {
			"3": 0,
			"4": 0.139323966408,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.017415495801,
			"4.1": 0.502561450258,
			"4.2-4.3": 1.25640362565,
			"4.4": 2.88102059109,
			"4.4.3-4.4.4": 2.9058998708
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.0839914182692,
			"9": 0.0191980384615,
			"10": 0.0311968125,
			"11": 0.363562853365,
			"5.5": null
		},
		"op_mob": {
			"0": 2.50116204389,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0694767234415
		},
		"edge": {
			"12": 0.070623,
			"13": 0.055062,
			"14": 0.056259
		},
		"ie_mob": {
			"10": 0.0746395211268,
			"11": 0.303889478873
		},
		"bb": {
			"7": 0.008803,
			"10": null
		},
		"samsung": {
			"0": 1.311647
		},
		"and_uc": {
			"0": 21.083185
		},
		"op_mini": {
			"0": 33.6977212327
		},
		"and_chr": {
			"0": 20.176447
		},
		"and_ff": {
			"0": 0.026409
		}
	},
	"total": 98.9465821226
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SO.json
 ** module id = 649
 ** module chunks = 0
 **/